import { put, takeLatest, call } from 'redux-saga/effects';
import {
  GET_CLIENT_CHECKINS,
  COMMENT_CHECKIN,
  MARK_CHECKIN_REVIEWED,
  GET_CURRENT_CHECKIN,
  SUBMIT_CHECKIN,
  GET_MY_CHECKINS,
} from './constants';
import {
  getClientCheckInsSuccess,
  getClientCheckInsError,
  commentCheckInSuccess,
  commentCheckInError,
  markCheckInReviewedSuccess,
  markCheckInReviewedError,
  getCurrentCheckInSuccess,
  getCurrentCheckInError,
  submitCheckInSuccess,
  submitCheckInError,
  getMyCheckInsSuccess,
  getMyCheckInsError,
} from './actions';
import { fetchData } from '../api';

function authConfig(method = 'GET', body) {
  const config = {
    method,
    headers: {
      'x-auth-token': window.localStorage.token,
      'Content-Type': 'application/json',
    },
  };
  if (body !== undefined) config.body = JSON.stringify(body);
  return config;
}

export function* getClientCheckIns({ clientId, limit }) {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/admin/check-ins/${clientId}?limit=${limit || 12}`;
    const data = yield call(fetchData, url, authConfig());
    yield put(getClientCheckInsSuccess(data));
  } catch (err) {
    let error = err;
    try {
      error = yield err.json();
    } catch (_) {
      // err wasn't a Response
    }
    yield put(getClientCheckInsError(error));
  }
}

export function* commentCheckIn({ checkInId, comment, aiDraftText }) {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/admin/check-ins/${checkInId}/comment`;
    // Forward `aiDraftText` only when present so the existing payload
    // shape stays unchanged for non-AI saves (no empty fields cluttering
    // the comment route's body validation).
    const body = aiDraftText ? { comment, aiDraftText } : { comment };
    const data = yield call(fetchData, url, authConfig('POST', body));
    yield put(commentCheckInSuccess(data));
  } catch (err) {
    let error = err;
    try {
      error = yield err.json();
    } catch (_) {
      // err wasn't a Response
    }
    yield put(commentCheckInError(error));
  }
}

export function* markCheckInReviewed({ checkInId }) {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/admin/check-ins/${checkInId}/reviewed`;
    const data = yield call(fetchData, url, authConfig('POST'));
    yield put(markCheckInReviewedSuccess(data));
  } catch (err) {
    let error = err;
    try {
      error = yield err.json();
    } catch (_) {
      // err wasn't a Response
    }
    yield put(markCheckInReviewedError(error));
  }
}

export function* getCurrentCheckIn() {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/check-ins/current`;
    const data = yield call(fetchData, url, authConfig());
    yield put(getCurrentCheckInSuccess(data));
  } catch (err) {
    let error = err;
    try {
      error = yield err.json();
    } catch (_) {
      // err wasn't a Response
    }
    yield put(getCurrentCheckInError(error));
  }
}

export function* submitCheckIn({ payload }) {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/check-ins`;
    const data = yield call(fetchData, url, authConfig('POST', payload));
    yield put(submitCheckInSuccess(data));
  } catch (err) {
    let error = err;
    try {
      error = yield err.json();
    } catch (_) {
      // err wasn't a Response
    }
    yield put(submitCheckInError(error));
  }
}

export function* getMyCheckIns({ limit }) {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/check-ins/me?limit=${limit || 12}`;
    const data = yield call(fetchData, url, authConfig());
    yield put(getMyCheckInsSuccess(data));
  } catch (err) {
    let error = err;
    try {
      error = yield err.json();
    } catch (_) {
      // err wasn't a Response
    }
    yield put(getMyCheckInsError(error));
  }
}

export default function* checkInSaga() {
  yield takeLatest(GET_CLIENT_CHECKINS, getClientCheckIns);
  yield takeLatest(COMMENT_CHECKIN, commentCheckIn);
  yield takeLatest(MARK_CHECKIN_REVIEWED, markCheckInReviewed);
  yield takeLatest(GET_CURRENT_CHECKIN, getCurrentCheckIn);
  yield takeLatest(SUBMIT_CHECKIN, submitCheckIn);
  yield takeLatest(GET_MY_CHECKINS, getMyCheckIns);
}
